<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m17.7 11.2-7.3 10.5q-.1.2-.4.3h-.4l-.3-.3-.1-.4V15H7.7q-.7 0-1.2-.5T6 13.3V3.8q0-.8.5-1.3T7.8 2H15q.7 0 1.2.6t.2 1.2L14.8 9h1.9q.9 0 1.1.7.4.7 0 1.4"
    />
  </svg>
</template>
